
const digest = '314ba1dfcb3f3567529d3f6a2584e3b259c1cbc3984b8b3fd0ca9e65955c32fd';
const css = `._selectionToolbar_s4l8q_1 {
  display: flex;
  position: absolute;
  transition: none !important; /* Disable popper transitions so toolbar doesn't zip around when changing selection. */

  box-shadow: var(--theme-shadow-shallow);
  background-color: var(--theme-primary-background);
  border: 1px solid var(--theme-light-border);
  border-radius: 4px;
  padding: 2px;

  --theme-editor-button-hovered: var(--aha-gray-200);
  transition: all 0.1s ease-out;
}
._selectionToolbarRight_s4l8q_15 {
  flex-direction: column;
}

.aha-fullscreen ._selectionToolbarRight_s4l8q_15 {
  margin-left: 10px;
}

._selectionToolbarAbove_s4l8q_23 {
  flex-direction: row;
}

._selectionToolbar_s4l8q_1 aha-tooltip {
  --Tooltip__tooltip--font-size: 14px;
}
`;

(function() {
  if (!document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
    
export default {"selectionToolbar":"_selectionToolbar_s4l8q_1","selectionToolbarRight":"_selectionToolbarRight_s4l8q_15","selectionToolbarAbove":"_selectionToolbarAbove_s4l8q_23"};
export { css, digest };
  